import ErrorOutline from "@mui/icons-material/ErrorOutline";
import { Box } from "@mui/material";
import React from "react";

interface Props {
  text: string;
  size?: "small" | "large";
  className?: string;
}

const styles = {
  "&.error": {
    borderLeft: "5px solid #ffb549",
    background: "rgba(255, 181, 73, 0.1)",
    padding: "4px 20px 4px 8px",
    fontStyle: "italic",
    display: "flex",
    alignItems: "center",
    fontSize: 12,
  },
  "& .icon": {
    color: "#FFB549",
    marginRight: "8px",
  },
};

const ErrorTemplate: React.FC<Props> = ({ text, size, className }) => {
  const combinedClassName = className ? `error ${className}` : "error";

  return (
    <Box sx={styles} className={combinedClassName}>
      <ErrorOutline fontSize={size || "small"} className={"icon"} />
      <span>{text}</span>
    </Box>
  );
};

export default ErrorTemplate;
